import { LOGOUT_CUSTOMER_360, LOGOUT_CUSTOMER_360_SUCCESS, LOGOUT_CUSTOMER_360_ERROR, LOGOUT_CUSTOMER_360_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const LogoutCustomer360 = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_CUSTOMER_360:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LOGOUT_CUSTOMER_360_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LOGOUT_CUSTOMER_360_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LOGOUT_CUSTOMER_360_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default LogoutCustomer360;
